import { MouseEventHandler } from "react"

import ShareButton from "./ShareButton"

export interface Props {
  ariaLabel?: string
  className?: string
  disabled?: boolean
  iconSize?: string
  loading?: boolean
  noHoverHighlight?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  transparent?: boolean
  type?: "button" | "reset" | "submit"
}

export interface ComponentProps extends Props {}

export default ShareButton
